import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentLeadsFunnelUpdateValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"

interface UseUpdateEstablishmentLeadManagersProps {
  id?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentLeadManagers = ({
  id,
  onSuccess,
  onError,
}: UseUpdateEstablishmentLeadManagersProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentLeadManagers'],
    mutationFn: (data: EstablishmentLeadsFunnelUpdateValidationSchema) => {
      const lead = {
        commercial_manager_id: data.commercial_manager?.value,
        commercial_manager_substitute_id: data.commercial_manager_substitute?.value || 'null',
      }

      return privateAxios.put(`/funnel/establishment/leads/${id}/update_managers`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
